import styled from '@emotion/styled'
import { Button } from 'antd'

export const AddNewItem = styled(Button)(props => ({
	border: 'none',
	boxShadow: 'none',
	marginTop: props.margin,
	marginBottom: props.margin,
	marginLeft: "10px"
}))